export default [
  [5, 13, 19, 27, 33, 41], // C
  [3, 11, 17, 25, 31, 39], // D
  [1, 9, 15, 23, 29, 37],  // E
  [7, 13, 21, 27, 35, 41], // F
  [5, 11, 19, 25, 33, 39], // G
  [3, 9, 17, 23, 31, 37],  // A
  [1, 7, 15, 21, 29, 35]   // B
]
